import { render, staticRenderFns } from "./PresentationQnA.vue?vue&type=template&id=0ce19f1c"
import script from "./PresentationQnA.vue?vue&type=script&lang=ts"
export * from "./PresentationQnA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports